<template>
  <v-btn
    :style="{
      width: width + 'px',
      height: height + 'px',
      color: textColor,
      lineHeight: '100%'
    }"
    :color="backgroundColor"
    :disabled="disabled"
    :loading="loading"
    :outline="outline"
    class="f-size-medium button-radius no-shadow"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 196
    },
    height: {
      type: [Number, String],
      required: false,
      default: 30
    },
    primary: {
      type: Boolean,
      required: false,
      default: false
    },
    brand: {
      type: Boolean,
      required: false,
      default: false
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    accent: {
      type: Boolean,
      required: false,
      default: false
    },
    new: {
      type: Boolean,
      required: false,
      default: false
    },
    white: {
      type: Boolean,
      required: false,
      default: false
    },
    yellow: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    outline: {
      type: Boolean,
      required: false,
      default: false
    },
    cloudsign: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    backgroundColor: function() {
      if (this.primary) {
        return 'dark_blue';
      }
      if (this.brand) {
        return 'calm_blue';
      }
      if (this.disabled) {
        return '#DEE1E6';
      }
      if (this.error) {
        return 'red';
      }
      if (this.accent) {
        return '#F95D84';
      }
      if (this.white) {
        return '#FFFFFF';
      }
      if (this.yellow) {
        return '#FFAA00';
      }
      if (this.flat) {
        return 'transparent';
      }
      if (this.new) {
        return '#ED8134';
      }
      if (this.cloudsign) {
        return '#001E5C';
      }
      return '#E9EAEF';
    },
    textColor: function() {
      if (this.primary || this.disabled || this.error || this.accent || this.new || this.cloudsign) {
        return '#fff';
      }
      return '#000';
    }
  }
};
</script>

<style scoped>
.v-btn {
  min-width: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/buttons/Button.vue